<template>
  <v-card flat @click="$router.push(action.resolutionPath)" class="action-item">
    <v-card-text>
      <v-layout align-center row class="px-4">
        <div>
          <v-icon
            v-if="$vuetify.breakpoint.smAndUp"
            :color="critical ? themes.candidate.light.error : themes.candidate.light.warning"
            left
          >
            mdi-checkbox-blank
          </v-icon>
        </div>
        <div class="px-4">
          <div class="font-weight-bold">
            <slot>Action Required</slot>
          </div>
          <div>
            {{ action.description }}
          </div>
        </div>
        <v-spacer />
        <div>
          <slot name="action">
            <v-icon
              :color="critical ? themes.candidate.light.error : themes.candidate.light.warning"
            >
              mdi-alert
            </v-icon>
          </slot>
        </div>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
// Vue Component
export default {
  props: { action: Object },

  computed: {
    critical() {
      return this.action.priority && this.action.priority > 5
    },
  },
}
</script>

<style>
.candidate.to.do.list .action-item {
  cursor: pointer;
}
</style>
